import { render, staticRenderFns } from "./SinalClinicoBoletimSanitario.vue?vue&type=template&id=304fa916&scoped=true&"
import script from "./SinalClinicoBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./SinalClinicoBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./SinalClinicoBoletimSanitario.vue?vue&type=style&index=0&id=304fa916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304fa916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow,VSimpleCheckbox,VSpacer})
